import { IHeSoUuTienTKBActionTypes } from "../../action-types/category/IHeSoUuTienTKBActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHeSoUuTienTKBReducer } from "../../reducer-model/category/IHeSoUuTienTKBReducer";

const initState: IHeSoUuTienTKBReducer = {
  status: eReducerStatusBase.is_not_initialization,
  heSoUuTienTKBs: [],
};
export const heSoUuTienTKBReducer = (
  state: IHeSoUuTienTKBReducer = initState,
  action: IHeSoUuTienTKBActionTypes
): IHeSoUuTienTKBReducer => {
  switch (action.type) {
    case "HE_SO_UU_TIEN_TKB_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HE_SO_UU_TIEN_TKB_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        heSoUuTienTKBs: action.payload,
      };
    case "HE_SO_UU_TIEN_TKB_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HE_SO_UU_TIEN_TKB_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        heSoUuTienTKBEditing: action.payload,
      };
    case "HE_SO_UU_TIEN_TKB_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "HE_SO_UU_TIEN_TKB_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HE_SO_UU_TIEN_TKB_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "HE_SO_UU_TIEN_TKB_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
